import type { SxProps, Theme } from '@mui/material';

/**
 * Coerce an `sx` prop (style object, theme callback, array, or undefined) into a
 * flat array so it can be safely merged/spread with other `sx` entries:
 *   sx={[baseSx, ...toSxArray(props.sx)]}
 *
 * The return type is intentionally inferred — annotating it (e.g. `SxProps[]`)
 * makes MUI's array `sx` form leak back in and breaks contextual typing at the
 * spread site.
 */
export function toSxArray(sx?: SxProps<Theme>) {
  if (Array.isArray(sx)) return sx;
  return sx ? [sx] : [];
}
